import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import PieChart from "../../../components/PieChart/PieChart";
import { useTheme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(2.5),
    border: `${theme.palette.secondary[300]} solid 1px`,
    borderRadius: "2.5px",
    padding: theme.spacing(0, 2, 2, 2)
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1)
  }
}));

export default function Compliance({
  compliancePercent,
  completedTraining,
  totalTrainingHours,
  courseAvg
}) {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Box className={classes.root}>
      <Box mt={2} mb={3} display="flex" justifyContent="center">
        <Typography variant="subtitle2">My Compliance</Typography>
      </Box>
      <Box alignSelf="center" mb={1} maxWidth={122}>
        <PieChart
          percent={compliancePercent}
          color={theme.palette.primary.main}
        />
      </Box>
      <Box className={classes.item}>
        <Typography variant="body2">Completed Training</Typography>
        <Typography variant="body2">{completedTraining}</Typography>
      </Box>
      <Divider />
      <Box className={classes.item}>
        <Typography variant="body2">Total Training Hours</Typography>
        <Typography variant="body2">{totalTrainingHours}</Typography>
      </Box>
      <Divider />
      <Box className={classes.item}>
        <Typography variant="body2">Training Average</Typography>
        <Typography variant="body2">{courseAvg + "%"}</Typography>
      </Box>
    </Box>
  );
}
